import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import './styles.css';
import { formatterDate } from '../modalCNH/functions/formatterDate';

export function ModalIntegrated({
  open,
  onClose,
  driversList,
  handleRemoveDriver,
  handleRegister,
  loading
}) {

  const CustomTableCell = withStyles(() => ({
    head: {
      height: 40,
    },
    body: {
      backgroundColor: '#F5F5F5',
      fontSize: 14,
      height: 40,
    },
  }))(TableCell);

  function addDays(dateString, days = 0) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + days);
    formatterDate(date);
    return `${formatterDate(date)}`;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'md'}
    >
      <DialogTitle>
        Alguns motoristas estão com a CNH próxima do vencimento:
      </DialogTitle>
      <DialogContent>
        <div style={{ overflowY: 'scroll', maxHeight: 400}}>
          <Table>
            <TableHead>
              <CustomTableCell>Nome</CustomTableCell>
              <CustomTableCell>Validade CNH</CustomTableCell>
              <CustomTableCell>Nova Validade Pesquisa</CustomTableCell>
              <CustomTableCell>Remover da Consulta</CustomTableCell>
            </TableHead>
            <TableBody>
              {driversList.length > 0 ?
                driversList.map((item) => {
                  if (!item.data.render) return null;
                  return (
                    <TableRow key={item.id}>
                      <CustomTableCell>{item.name}</CustomTableCell>
                      <CustomTableCell>
                        {item.cnhValidity.split('-').reverse().join('/')}
                      </CustomTableCell>
                      <CustomTableCell>
                        {
                          addDays(item.cnhValidity, 30)
                        }
                      </CustomTableCell>
                      <CustomTableCell>
                        <div style={{ display: 'flex', justifyContent: 'center'}}>
                          <IconButton
                            onClick={
                              () => handleRemoveDriver(item.id)
                            }
                            disabled={loading}
                          >
                            <CloseIcon color='error' />
                          </IconButton>
                        </div>
                      </CustomTableCell>
                    </TableRow>
                  );
                })
                : <TableRow>
                  <CustomTableCell colSpan={4} align='center'>
                    Carregando...
                  </CustomTableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </div>

        <div style={{
          marginTop: 35,
        }}>
          <Typography>
          A validade das pesquisas será de acordo com a data especificada na coluna
          </Typography>
          <Typography>
          &quot;Nova Validade Pesquisa&quot; devido à vigência da CNH,
          com um período adicional de 30 dias.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          style={{
            color: '#37BEE7',
          }}
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          style={{
            color: '#37BEE7',
          }}
          onClick={handleRegister}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
